/* Keep consultation after the first actual product row, including filtered/AJAX grids. */
(()=>{'use strict';
 const roots=[...document.querySelectorAll('[data-ef-consultation-flow]')];if(!roots.length)return;
 let pending=false;
 function place(){pending=false;roots.forEach(root=>{
  const grid=root.querySelector('[data-efxc-grid]'),rail=grid?.querySelector(':scope > .efxc-rail');if(!rail)return;
  const cards=[...grid.children].filter(e=>e.matches('.efx-card')&&!e.matches('[data-lexington-custom-card],[data-efmc-custom-steel]')&&!e.hidden);
  if(!cards.length)return;
  const gap=parseFloat(getComputedStyle(grid).columnGap)||0;
  const cols=Math.max(1,Math.round((grid.clientWidth+gap)/(cards[0].getBoundingClientRect().width+gap)));
  const target=cards[Math.min(cols,cards.length)-1];
  if(target.nextElementSibling!==rail)target.after(rail);
 });}
 function queue(){if(!pending){pending=true;requestAnimationFrame(place);}}
 roots.forEach(root=>new MutationObserver(queue).observe(root,{childList:true,subtree:true}));
 window.addEventListener('resize',queue,{passive:true});queue();
})();
